import { useEffect } from "react";

export const useSetSeedFromSeries = ({ series, name, value, setValue }) => {
    useEffect(() => {
        if (series.length && (!value || !series.includes(value))) setValue(name, series[0]);
        if (!series.length && value) setValue(name, null);
    }, [series, value]);
};
